import { createRouter, createWebHistory } from 'vue-router';
import TheReservationPage from './pages/ReservationPage.vue';
import PageNotFound from './pages/PageNotFound.vue';
import HomePage from './pages/HomePage.vue';
import CustomerPanelPage from './pages/CustomerPanelPage.vue';
import LevelPage from './pages/customer/LevelPage.vue';
import ProfilePage from './pages/customer/Profile.vue';
import OrdersPage from './pages/customer/Orders.vue';
import UnsubscribePage from './pages/customer/Unsubscribe.vue';
import OrderStatusPage from './pages/OrderStatusPage.vue';
import AuthorizationPage from './pages/AuthorizationPage.vue';
import CoursesPage from './pages/customer/Courses.vue';

import rpAPI from '@shared/service/rpAPI.js';
import Globals from '@shared/model/Globals';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/order/:id',
    name: 'Order Status',
    component: OrderStatusPage
  },
  {
    path: '/authorization',
    name: 'Authorization',
    component: AuthorizationPage,
  },
    {
    path: '/logout',
    name: 'Logout',
  },
  {
    path: '/customer',
    component: CustomerPanelPage,
    children: [
      {
        path: '',
        redirect: '/customer/courses'
      },
      {
        path: 'courses',
        name: 'CustomerCourses',
        component: CoursesPage
      },
      {
        path: 'level',
        name: 'CustomerLevel',
        component: LevelPage
      },
      {
        path: 'data',
        redirect: '/customer/profile',
      },
      {
        path: 'profile',
        name: 'CustomerProfile',
        component: ProfilePage
      },
      {
        path: 'orders',
        name: 'CustomerOrders',
        component: OrdersPage
      },
      {
        path: 'unsubscribe',
        name: 'CustomerUnsubscribe',
        component: UnsubscribePage
      }
    ]
  },
  {
    path: '/:id/:groupId?',
    name: 'Reservation',
    component: TheReservationPage,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: PageNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  await rpAPI.ensureUser(); // Ensure we have the user's authentication status before checking routes

  if (to.name === 'Logout') {
    rpAPI.logout();
       
      const referrer = document.referrer || Globals.APP_HOME_URL;
      
      const isHttps = window.location.protocol === 'https:';

        const getSharedDomain = (hostname) => {
          // don't try to set `domain=` for localhost/ip
          if (hostname === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return null;

          const parts = hostname.split('.');
          if (parts.length < 2) return null;

          // best-effort eTLD+1 (e.g. sub.example.com -> .example.com)
          return `.${parts.slice(-2).join('.')}`;
        };

        const clearCookie = (name, { domain, secure } = {}) => {
          document.cookie =
          `${encodeURIComponent(name)}=` +
          `; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT` +
          `; Path=/` +
          `; SameSite=Lax` +
          (domain ? `; Domain=${domain}` : '') +
          (secure ? `; Secure` : '');
        };

        const hostname = window.location.hostname;
        const sharedDomain = getSharedDomain(hostname);

        // Try clearing host-only cookie (no Domain=) and shared-domain cookie (Domain=.example.com),
        // and try both secure and non-secure variants.
        ['reservepro_session'].forEach((cookieName) => {
          clearCookie(cookieName, { secure: false });
          clearCookie(cookieName, { secure: isHttps });

          if (sharedDomain) {
          clearCookie(cookieName, { domain: sharedDomain, secure: false });
          clearCookie(cookieName, { domain: sharedDomain, secure: isHttps });
          }
        });

        window.location.href = referrer; // Redirect to the referring page or home after logout
        return "/customer"; // Redirect to home after logout
  }


  const isCustomerRoute = to.path === '/customer' || to.path.startsWith('/customer/');

  if (isCustomerRoute) {
   
    if (!rpAPI.isLoggedIn() && to.name !== 'Authorization' && to.name !== 'Registration') {
      return {
        name: 'Authorization',
        query: { redirect: to.fullPath },
      };
    }
    // we have in modules  Authorization and Registration redirection
  }


});

export default router;